export enum RuleMessageLevel {
  Info = 0,
  Warning = 1,
  Error = 2,
}

export type RuleMessage = {
  level: RuleMessageLevel;
  text: string;
  messages?: RuleMessage[];
  keys?: { [key: string]: string | boolean };
};

export type Rule = (fact: unknown) => Promise<RuleMessage[] | undefined | void>;

export type MutateResult<MutateType> = {
  isSuccess: boolean;
  mutated?: MutateType;
  messages: RuleMessage[];
};

export type BulkMutateResult<MutateType> = {
  isSuccess: boolean;
  mutated?: MutateType[];
  messages: RuleMessage[];
};

export const isRuleMessageArray = (ruleMessages: unknown): ruleMessages is RuleMessage[] => {
  if (!ruleMessages) return false;
  if (!Array.isArray(ruleMessages)) return false;
  if (!ruleMessages.every((x) => isRuleMessage(x))) return false; // only checking the first level
  return true;
};

export const isRuleMessage = (ruleMessage: RuleMessage): ruleMessage is RuleMessage => {
  if (!ruleMessage) return false;
  if (typeof ruleMessage.level !== 'number') return false;
  if (!ruleMessage.text) return false;
  return true;
};
